import { render, staticRenderFns } from "./ContactSelector.vue?vue&type=template&id=10d17884"
import script from "./ContactSelector.vue?vue&type=script&lang=ts"
export * from "./ContactSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports